//app.js
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SubscriptionProvider } from "./context/SubscriptionContext";
import { MyProvidersProvider } from "./context/MyProvidersContext";
import AuthTokenBridge from "./components/AuthTokenBridge";
import { MyVendorsProvider } from "./context/MyVendorsContext";
import Navbar from "./components/Navbar";
import UpgradeModal from "./components/UpgradeModal";
import HomePage from "./pages/HomePage";
import ResultsPage from "./pages/ResultsPage";
import PhysicianPage from "./pages/PhysicianPage";
import CompanyPage from "./pages/CompanyPage";
import AboutPage from "./pages/AboutPage";
import CompanySearchPage from "./pages/CompanySearchPage";
import ComparePage from "./pages/ComparePage";
import CompanyResultsPage from "./pages/CompanyResultsPage";
import SuccessPage from "./pages/SuccessPage";
import PhysicianOwnersPage from "./pages/PhysicianOwnersPage";
import PhysicianResearchPage from "./pages/PhysicianResearchPage";
import CompanyProfilePage from "./pages/CompanyProfilePage";
import MyProvidersPage from "./pages/MyProvidersPage";
import MyVendorsPage from "./pages/MyVendorsPage";
import MyProviderListProfilePage from "./pages/MyProviderListProfilePage";
import BuildListPage from "./pages/BuildListPage";
import CompareListsPage from "./pages/CompareListsPage";
import ConflictReportPage from "./pages/ConflictReportPage";
import ReviewedFindingsPage from "./pages/ReviewedFindingsPage";
import CoiProvidersPage from "./pages/CoiProvidersPage";
import { CompareProvider } from "./context/CompareContext";
import CompareBar from "./components/CompareBar";
import { CompanyCompareProvider } from "./context/CompanyCompareContext";
import CompanyCompareBar from "./components/CompanyCompareBar";
import CompanyComparePage from "./pages/CompanyComparePage";
import { DEFAULT_YEAR } from "./utils/cmsApi";

export default function App() {
  const year = DEFAULT_YEAR;
  return (
    <SubscriptionProvider>
      <AuthTokenBridge />
      <MyProvidersProvider>
      <MyVendorsProvider>
      <CompareProvider>
      <CompanyCompareProvider>
      <BrowserRouter>
        <div className="min-h-screen">
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/results" element={<ResultsPage />} />
            <Route path="/physician/:npi" element={<PhysicianPage />} />
            <Route path="/physician/:npi/company/:companyName" element={<CompanyPage />} />
            <Route path="/physician/:npi/ownership" element={<PhysicianOwnersPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/company-search" element={<CompanySearchPage />} />
            <Route path="/compare" element={<ComparePage year={year} />} />
            <Route path="/company-results" element={<CompanyResultsPage year={year} />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/physician/:npi/research" element={<PhysicianResearchPage />} />
            <Route path="/company/:companyId" element={<CompanyProfilePage />} />
            <Route path="/my-providers" element={<MyProvidersPage />} />
            <Route path="/my-vendors" element={<MyVendorsPage />} />
            <Route path="/my-providers/:listId/profile" element={<MyProviderListProfilePage />} />
            <Route path="/build-list" element={<BuildListPage />} />
            <Route path="/compare-lists" element={<CompareListsPage />} />
            <Route path="/conflict-report/:reportId" element={<ConflictReportPage />} />
            <Route path="/reviewed-findings" element={<ReviewedFindingsPage />} />
            <Route path="/coi-providers" element={<CoiProvidersPage />} />
            <Route path="/compare-companies" element={<CompanyComparePage />} />
          </Routes>
          <UpgradeModal />
          <CompareBar />
          <CompanyCompareBar />
        </div>
      </BrowserRouter>
      </CompanyCompareProvider>
      </CompareProvider>
      </MyVendorsProvider>
      </MyProvidersProvider>
    </SubscriptionProvider>
  );
}